import City from "./KrCity.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCity = install(City); // 生成带有 install 方法的组件

export default KrCity;
